var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenuNft = function SvgMenuNft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "nft_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nft_24dp"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0281592,9 L13.0340243,9 L13.0340243,11 L11.0281592,11 L11.0281592,9 Z M9.0222941,11 L11.0281592,11 L11.0281592,13 L9.0222941,13 L9.0222941,11 Z M13.0340243,11 L15.0398894,11 L15.0398894,13 L13.0340243,13 L13.0340243,11 Z M15.0398894,9 L17.0457545,9 L17.0457545,11 L15.0398894,11 L15.0398894,9 Z M7.016429,9 L9.0222941,9 L9.0222941,11 L7.016429,11 L7.016429,9 Z M19.0516196,3 L5.0105639,3 C3.90733809,3 3.0046988,3.9 3.0046988,5 L3.0046988,19 C3.0046988,20.1 3.90733809,21 5.0105639,21 L19.0516196,21 C20.1548454,21 21.0574847,20.1 21.0574847,19 L21.0574847,5 C21.0574847,3.9 20.1548454,3 19.0516196,3 Z M9.0222941,18 L7.016429,18 L7.016429,16 L9.0222941,16 L9.0222941,18 Z M13.0340243,18 L11.0281592,18 L11.0281592,16 L13.0340243,16 L13.0340243,18 Z M17.0457545,18 L15.0398894,18 L15.0398894,16 L17.0457545,16 L17.0457545,18 Z M19.0516196,11 L17.0457545,11 L17.0457545,13 L19.0516196,13 L19.0516196,15 L17.0457545,15 L17.0457545,13 L15.0398894,13 L15.0398894,15 L13.0340243,15 L13.0340243,13 L11.0281592,13 L11.0281592,15 L9.0222941,15 L9.0222941,13 L7.016429,13 L7.016429,15 L5.0105639,15 L5.0105639,13 L7.016429,13 L7.016429,11 L5.0105639,11 L5.0105639,5 L19.0516196,5 L19.0516196,11 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};

export { SvgMenuNft as ReactComponent };
export default __webpack_public_path__ + "2cb7c9326ec2ce503565faf69c4eb708.svg";